import SidebarContainer from 'src/legacy/components/Sidebar/SidebarContainer';

export default SidebarContainer;
